import { MessageEntity } from "@/indexedDB/types";

type Props = {
  message: MessageEntity;
};

export default function ServiceMessageListItem({ message }: Props) {
  return (
    <div className="message-list-item flex items-center justify-center gap-3">
      <div className="text-sm font-normal text-foreground/50">
        <p className="break-all">
          {message.content.text?.replace(/<[^>]*>?/gm, "")}
        </p>
      </div>
    </div>
  );
}
